import React from "react";
import { HorizontalBar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { fmtNum } from "./helpers";
import { STATUS_COLOR, CAP_COLOR, BAR_ROW_H } from "./constants";

export default function BarChart({ items, statusLabels }) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language;
  const rows = items || [];

  const data = {
    labels: rows.map((r) => r.name),
    datasets: [
      {
        label: t("schools.chCap"),
        data: rows.map((r) => r.capacity),
        backgroundColor: CAP_COLOR,
        barPercentage: 0.9,
        categoryPercentage: 0.74,
      },
      {
        label: t("schools.chStudents"),
        data: rows.map((r) => (r.status === "no_data" ? null : r.students)),
        backgroundColor: rows.map((r) => STATUS_COLOR[r.status]),
        barPercentage: 0.9,
        categoryPercentage: 0.74,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false }, // легенда рисуется в JSX ниже
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(139,149,168,.12)",
            zeroLineColor: "rgba(139,149,168,.2)",
          },
          ticks: { fontColor: "#8b95a8", beginAtZero: true },
        },
      ],
      yAxes: [
        {
          gridLines: { display: false },
          ticks: {
            fontColor: "#c7ced9",
            fontSize: 11,
            autoSkip: false,
            callback: (label) =>
              label.length > 44 ? label.slice(0, 44) + "…" : label,
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        title: (its) => rows[its[0].index].name,
        label: (item, dt) => {
          const ds = dt.datasets[item.datasetIndex];
          const raw = ds.data[item.index];
          return `${ds.label}: ${raw == null ? "—" : fmtNum(raw, lng)}`;
        },
      },
    },
  };

  const statusesPresent = ["good", "bad", "no_data"].filter((s) =>
    rows.some((r) => r.status === s),
  );
  const legend = [
    { text: t("schools.chCap"), color: CAP_COLOR },
    ...statusesPresent.map((s) => ({
      text: `${t("schools.chStudents")}: ${statusLabels[s] || s}`,
      color: STATUS_COLOR[s],
    })),
  ];

  const height = Math.max(rows.length * BAR_ROW_H + 60, 300);
  const sig = rows.map((r) => `${r.id}:${r.students}:${r.status}`).join("|");

  return (
    <div className="sch-chart-wrap">
      <div className="sch-chart-legend">
        {legend.map((l, i) => (
          <span className="item" key={i}>
            <i className="sw" style={{ background: l.color }} />
            {l.text}
          </span>
        ))}
      </div>
      <div className="sch-chart-box" style={{ height }}>
        <HorizontalBar key={sig} data={data} options={options} />
      </div>
    </div>
  );
}
